import axios from 'axios';

const AxiosInstance = (function () {
  let instance = null;
  function Singleton() {
    if (instance) {
      return instance;
    }
    instance = this;
  }
  Singleton.getInstance = function () {
    if (!instance) {
      instance = axios.create({
        timeout: 30000,
        headers: {
          'Content-Type': 'application/json',
        },
      });
    }
    return instance;
  };
  return Singleton;
})();

export { AxiosInstance as ExternalHttpClient };
